import { APIModel } from 'app/state/api';
import { ApiCallModel } from 'app/state/api/interfaces';

const roles: ApiCallModel = {
  ...APIModel(`${process.env.REACT_APP_AUTH_API}/roles`),
};

export default roles;
